"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = void 0;
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _CenterBox = require("./CenterBox");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Progress = exports.Progress = function Progress() {
  /*
    useEffect(() => {
      const timer = setTimeout(() => setTransitioning(false), 450);
      return () => clearTimeout(timer);
    }, []);
    */

  return /*#__PURE__*/_react.default.createElement(_CenterBox.CenterBox, {
    marginTop: "-20px",
    marginLeft: "-50px"
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, null));
};